import { httpGet, httpDelete } from '../../../Util/http';



export const FETCH_SALARY_PROJECTS_REQUEST = 'FETCH_SALARY_PROJECTS_REQUEST'
export const fetchProjectsRequest = () => {
    return {
        type: FETCH_SALARY_PROJECTS_REQUEST
    }
}

export const FETCH_SALARY_PROJECTS_SUCCESS = 'FETCH_SALARY_PROJECTS_SUCCESS'
export const fetchProjectsSuccess = (json) => {
    let projects = json.map((project) => {
        return { ...project, isSelected: true }
    })
    return {
        type: FETCH_SALARY_PROJECTS_SUCCESS,
        projects: projects
    }
}

export const FETCH_SALARY_PROJECTS_FAILURE = 'FETCH_SALARY_PROJECTS_FAILURE'
export const fetchProjectsFailure = () => {
    return {
        type: FETCH_SALARY_PROJECTS_FAILURE
    }
}

export const attemptFetchProjects = () => {
    var _url = process.env.REACT_APP_webApiEndPoint + "api/user/projects/";
    return (dispatch) => {
        dispatch(fetchProjectsRequest());
        return httpGet(_url)
            .then(response => {
                return response.json();
            })
            .then((json) => dispatch(fetchProjectsSuccess(json)))
            .catch(() => {
                dispatch(fetchProjectsFailure());
            })
    }
}


export const ADD_PROJECT = 'ADD_PROJECT';
export function addProject(project) {
    return {
        type: ADD_PROJECT,
        project: { ...project, isSelected: true }
    }
}

export const REMOVE_PROJECT_FROM_LIST = 'REMOVE_PROJECT_FROM_LIST'
export function removeProject(projectId, index, isSelected) {
    return dispatch => {
        let _url = process.env.REACT_APP_webApiEndPoint + `api/salary/list?id=${projectId}`;
        dispatch(setProjectIsSelected(index, false))
        httpDelete(_url, projectId)
            .then(() => dispatch({
                type: REMOVE_PROJECT_FROM_LIST,
                projectId,
                index
            }))
            .catch(() => {
                dispatch(setProjectIsSelected(index, isSelected))
                alert('der skete en fejl')
            })
    }
}

export const SET_PROJECT_IS_SELECTED = 'SET_PROJECT_IS_SELECTED';
export function setProjectIsSelected(projectIndex, isSelected) {
    return {
        type: SET_PROJECT_IS_SELECTED,
        projectIndex: projectIndex,
        isSelected: isSelected
    }
}

export const SET_SALARY_DATES = 'SET_SALARY_DATES';
export function setSalaryDates(startDate, endDate) {
    return {
        type: SET_SALARY_DATES,
        startDate: startDate,
        endDate: endDate
    }
}



export const GET_PROJECT_SUGGESTIONS_SUCCESS = 'GET_PROJECT_SUGGESTIONS_SUCCESS';
export function getProjectSuggestionsSuccess(suggestions) {
    return {
        type: GET_PROJECT_SUGGESTIONS_SUCCESS,
        suggestions: suggestions
    }
}



export function getSuggestions(val) {

    var fetchUrl = process.env.REACT_APP_webApiEndPoint + `api/project/search?query=${val}&all=true`;
    return (dispatch, getState) => {
        if (!val) {
            dispatch(getProjectSuggestionsSuccess([]))
            return;
        }
        return httpGet(fetchUrl)
            .then(response => {
                return response.json();
            })
            .then((json) => {
                let jsonReponse = stripSuggestions(json, getState().createSalaryReducer.projects)
                dispatch(getProjectSuggestionsSuccess(jsonReponse))
            })
            .catch((e) => {
                console.log(e);
            })
    };
}

function stripSuggestions(suggestions, alreadyChosen) {
    var newSuggestions = [];
    suggestions.forEach(function (suggestion) {
        var allowedSugg = true;
        //check if already chosen from suggestions
        alreadyChosen.forEach(function (chosen) {
            if (chosen.id === suggestion.id) allowedSugg = false;
        });

        if (allowedSugg) newSuggestions.push(suggestion);
    })
    return newSuggestions;
}





// WEBPACK FOOTER //
// ./src/App/Project/Salary/CreateSalary/actions.js